// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseKandaCurry() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>神田カレーグランプリ2025</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>イベント・観光</span>
            <span>ブロックチェーン事業開発</span>
          </div>
          <h1 className="cd-title">
            スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
          </h1>
          <p className="cd-client">広告代理店</p>
          <div className="cd-img is-cover">
            <span className="cover-en">NFT STAMP RALLY</span>
            <span className="cover-ja">スタンプラリー × NFT</span>
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                企画が終わった後もスタンプを残したいというユーザーの声に応えたい。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>既存のスタンプラリーアプリに組み込めるNFTのAPIを提供。</p>
            </div>
            <div>
              <span>成果</span>
              <p>4.5か月で参加者5,633人、NFT発行数79,819。</p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <div className="cd-stats">
            <div>
              <p className="cd-stat-num">
                4.5<small>か月</small>
              </p>
              <p className="cd-stat-lab">開催期間</p>
            </div>
            <div>
              <p className="cd-stat-num">
                5,633<small>人</small>
              </p>
              <p className="cd-stat-lab">参加者数</p>
            </div>
            <div>
              <p className="cd-stat-num">
                79,819
                <small />
              </p>
              <p className="cd-stat-lab">NFT発行数</p>
            </div>
          </div>
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              広告代理店が支援する「神田カレーグランプリ2025」のスタンプラリーで、スタンプカード・スタンプ・特典をすべてNFTとして参加者に付与しました。LEAPSのブロックチェーンアプリ開発キット（Dapps
              Developer
              Tools）を導入いただき、イベントが終わった後も、参加の記録が手元に残る体験をつくりました。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>
                スタンプを、企画が終わった後にも残しておきたいというユーザーの声があった
              </li>
              <li>
                NFTのアイデアはあったが、サービスとしての設計ができていなかった
              </li>
              <li>
                ブロックチェーンのサービス開発に実績のあるパートナーと進めたかった
              </li>
              <li>
                アプリは既存のベンダーが開発しているため、役割を切り分ける必要があった
              </li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">チーム体制</p>
                <h3 className="cd-ptitle">
                  ブロックチェーンに精通したメンバーで伴走
                </h3>
                <p>
                  ブロックチェーンに精通したメンバーをアサインし、企画から実装まで一緒に進めました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">サービス設計</p>
                <h3 className="cd-ptitle">今の使い心地を崩さないNFT体験</h3>
                <p>
                  参加者がNFTやウォレットを意識しなくても使えるよう、既存アプリの使い心地を崩さないサービス設計を行いました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">API提供</p>
                <h3 className="cd-ptitle">既存アプリに組み込めるNFTのAPI</h3>
                <p>
                  既存のスタンプラリーアプリに組み込めるNFTのAPIを提供し、ブロックチェーン開発の経験がないアプリ側のエンジニアでも実装できる形にしました。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>成果</h2>
            <p>
              4.5か月の開催期間で、5,633人が参加し、79,819のNFTが発行されました。2026年の開催に向けて、ほかのイベントにも使える形への汎用化を進めています。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/hikky">
              <div className="case-img is-cover">
                <span className="cover-en">METAVERSE NFT</span>
                <span className="cover-ja">メタバース × NFT</span>
              </div>
              <p className="case-meta">メタバース事業会社</p>
              <h3>メタバース霊園の土地と遺品を、NFTで受け継げる仕組みに</h3>
              <div className="case-tags">
                <span>メタバース・エンタメ</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
